export default [
  {
    title: "일반화재",
    list: [
      {
        content: "흡연 장소를 통제한다.(실내 및 흡연장소의 소화기 비치)",
        isChecked: "",
      },
      {
        content: "인화성물질(라이터, 성냥 등) 및 화기장소(주방, 보일러실 등)를 통제한다.",
        isChecked: "",
      },
      {
        content: "건물 주변 산림의 수목 등을 제거하여 안전관리를 확보한다.",
        isChecked: "",
      },
      {
        content: "쓰레기를 분리수거(품목별 분리, 차광 및 화기통제)한다.",
        isChecked: "",
      },
      {
        content: "주방 조리기구의 착화원 및 후드 등을 정기적으로 청소한다.",
        isChecked: "",
      },
      {
        content: "유류사용 시 누설 방지 대책 및 안전시설(소화기, 방화사 등)을 구비한다.",
        isChecked: "",
      },
      {
        content: "화기시설 주위의 가연물을 제거한다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "유류화재",
    list: [
      {
        content: "유류 사용기기별로 책임자를 임명하여 사용 및 관리한다.",
        isChecked: "",
      },
      {
        content: "과열이 되기 쉬운 가전제품, 보일러 등은 무리해서 사용하지 말고, 항상 사용전 안전점검 후에 사용한다.",
        isChecked: "",
      },
      {
        content: "유류 사용기기 주변에 가연물의 적재를 금지한다.",
        isChecked: "",
      },
      {
        content: "화공약품 및 유류 사용 장소에는 적응성 있는 소화기를 비치한다.",
        isChecked: "",
      },
      {
        content: "흡연장소의 지정 및 소화기 등 화재 안전대책을 강구한다.",
        isChecked: "",
      },
      {
        content: "용접 등 실내 작업을 지양하고 불가피한 경우 안전대책 수립 후 감독자 입회하에 실시한다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "전기화재",
    list: [
      {
        content: "퓨즈나 과전류차단기, 전선 등은 정격용량의 제품을 사용한다.",
        isChecked: "",
      },
      {
        content: "용량에 적합한 규격전선의 사용 및 노후된 배선은 교체한다.",
        isChecked: "",
      },
      {
        content: "천정 속 및 전기기기의 청소 등을 통해 먼지나 가루를 제거한다.",
        isChecked: "",
      },
      {
        content: "문어발식 콘센트 사용을 금지하고, 전기기기는 사용 후 플러그를 제거한다.",
        isChecked: "",
      },
      {
        content: "분전함 등 전기시설 부근에는 위험물, 기타 가연물의 방치를 금지한다.",
        isChecked: "",
      },
      {
        content: "전열기 등의 자동온도조절장치 작동여부 등을 수시로 점검한다.",
        isChecked: "",
      },
      {
        content: "전기장판 등 불필요한 전열기기를 사용하지 않는다.",
        isChecked: "",
      },
      {
        content: "젖은 손으로 전기를 취급하지 않는다.",
        isChecked: "",
      },
    ],
  },
  {
    title: "가스화재",
    list: [
      {
        content: "가스시설 사용 시 장시간 자리 이탈을 금지한다.",
        isChecked: "",
      },
      {
        content: "가스사용 전 가스누설 여부를 냄새로 확인하고 환기시킨 후 사용한다.",
        isChecked: "",
      },
      {
        content: "가스사용 후(외출 시) 중간 또는 안전밸브를 폐쇄한다.",
        isChecked: "",
      },
      {
        content: "가스사용 주위의 위험성 및 가연성 물질 방치를 금지한다.",
        isChecked: "",
      },
      {
        content: "호스와 밸브 등은 비눗물을 이용하여 누설여부를 정기적으로 점검한다.",
        isChecked: "",
      },
      {
        content: "장시간 사용하지 않는 경우 중간밸브와 메인밸브를 잠근다.",
        isChecked: "",
      },
      {
        content: "휴대용 부탄가스, 헤어스프레이 등은 반드시 구멍을 뚫어 버린다.",
        isChecked: "",
      },
      {
        content: "가스 점화 시 불이 붙었는지 반드시 확인한다.",
        isChecked: "",
      },
    ],
  },
];
